// src/telas/editar-tecnico/dados-basicos/index.tsx

import { RxDotFilled } from "react-icons/rx";
import styles from "../styles.module.css";
import { useContext } from "react";
import { FormularioContext } from "..";
import { capitalizarPrimeiraLetraMaiusculaDeCadaPalavra, formatarCPFouCNPJ } from "../../../formatting/formatting";

export function DadosBasicos() {
  const context = useContext(FormularioContext);

  function atualizarFormulario(event: React.ChangeEvent<HTMLInputElement>) {
    let nome = event.target.name;
    let value = `${event.target.value}`;

    if (nome === "A2_CGC") {
      value = formatarCPFouCNPJ(value);

      context?.setFormulario({
        ...context.formulario,
        ...{ [nome]: value,
           A2_TIPO: value.length > 14 ? "J" : "F" },
      });
    } else {
      context?.setFormulario({ ...context.formulario, ...{ [nome]: value } });
    }
  }

  return (
    <>
      {/* CPF / CNPJ */}
      <div className={styles.formGroup}>
        <div className={styles.groupInput}>
         <span>
            {!context?.formulario.A2_CGC
              ? "CPF/CNPJ"
              : context?.formulario.A2_CGC.length === 18
                ? "CNPJ"
                : context?.formulario.A2_CGC.length === 14
                  ? "CPF"
                  : "CPF/CNPJ"}{" "}
            <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            value={formatarCPFouCNPJ(context?.formulario.A2_CGC || "")}
            type="text"
            name="A2_CGC"
            onChange={atualizarFormulario}
            placeholder="Digite seu CPF ou CNPJ"
            maxLength={18}
          />
          <label>Digite apenas números</label>
        </div>
      </div>

      {/* NOME */}
      <div className={styles.groupInput}>
        <span>
          Nome <RxDotFilled size={16} className={styles.legend} />
        </span>
        <input
          maxLength={40}
          value={capitalizarPrimeiraLetraMaiusculaDeCadaPalavra(context?.formulario.A2_NOME || "")}
          type="text"
          name="A2_NOME"
          onChange={atualizarFormulario}
          placeholder={
            context?.formulario.A2_TIPO === "J"
              ? "Nome completo da empresa"
              : "Nome completo"
          }
          style={{ width: "100%" }}
        />
      </div>

      {/* NOME FANTASIA — apenas PJ */}
      {context?.formulario.A2_TIPO === "J" && (
        <div className={styles.groupInput}>
          <span>
            Nome Fantasia <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            value={capitalizarPrimeiraLetraMaiusculaDeCadaPalavra(context?.formulario.A2_NREDUZ || "")}
            type="text"
            name="A2_NREDUZ"
            onChange={atualizarFormulario}
            placeholder="Nome fantasia da empresa"
            style={{ width: "100%" }}
          />
        </div>
      )}

      {/* INSCRIÇÕES — apenas PJ */}
      {context?.formulario.A2_TIPO === "J" && (
        <div className={styles.formGroup}>
          <div className={styles.groupInput}>
            <span>Inscrição Estadual</span>
            <input
              value={context?.formulario.A2_INSCR}
              type="text"
              name="A2_INSCR"
              onChange={atualizarFormulario}
              placeholder=""
            />
            <label>Digite apenas números</label>
          </div>
          <div className={styles.groupInput}>
            <span>Inscrição Municipal</span>
            <input
              value={context?.formulario.A2_INSCRM}
              type="text"
              name="A2_INSCRM"
              onChange={atualizarFormulario}
              placeholder=""
            />
            <label>Digite apenas números</label>
          </div>
        </div>
      )}

      {/* SENHA */}
      <div className={styles.groupInput}>
        <span>Senha (preencha apenas se desejar alterar)</span>
        <input
          maxLength={20}
          value={context?.formulario.A2_ZSENHA}
          type="password"
          name="A2_ZSENHA"
          onChange={atualizarFormulario}
          placeholder="Nova senha de acesso"
          style={{ width: "100%" }}
        />
      </div>

      {/* CONFIRMAÇÃO DE SENHA */}
      <div className={styles.groupInput}>
        <span>Confirmação de Senha</span>
        <input
          maxLength={20}
          value={context?.formulario.A2_ZSENHA_CONFIRM}
          type="password"
          name="A2_ZSENHA_CONFIRM"
          onChange={atualizarFormulario}
          placeholder="Confirme a nova senha"
          style={{ width: "100%" }}
        />
      </div>
    </>
  );
}